module.exports = __webpack_public_path__ + "static/media/pending_evaluation_grey.406d76c3.svg";